import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; /** for ngModel & forms **/

/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NgZorroAntdModule } from 'app/ng-zorro.module';
import { NgxCurrencyModule } from "ngx-currency";
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);
/*
Base UI includes { ngx-charts } was the base charting library
- Check Docs: https://swimlane.gitbook.io/ngx-charts/examples/pie-charts/pie-grid-chart
- Check Demo: https://swimlane.github.io/ngx-charts/#/ngx-charts/advanced-pie-chart
*/
import { NgxChartsModule } from '@swimlane/ngx-charts'; /* ngx-charts */

//Routing Module for the specific View Module
import { InboxSortService } from '../../BaseFramework/core/http'


import { BaseUIModule } from '../../BaseFramework'
import { CustomPipesModule } from 'app/BaseFramework/shared/custom-pipes/custom-pipes.module';

//ViewModule Components
// import { NBCaptureProposalComponent } from './nb-capture-proposal/nb-capture-proposal.component';

//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services';
import { SharedComponentsModule } from '../shared-components';
import { NewBusinessRoutingModule } from './newbusiness-routing.module';

const services = [InboxSortService]


@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    NewBusinessRoutingModule,
    NgZorroAntdModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BaseUIModule,
    CustomPipesModule,
    NgxCurrencyModule,
    TranslateModule.forChild({
      isolate: true
    })
  ],
  exports: [NewBusinessRoutingModule,
    // NBCaptureProposalComponent
  ],
  declarations: [
    // NBCaptureProposalComponent,
    
  ],
  providers: [...services]
})
export class NewBusinessModule { 

  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService:MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }

  
}
